"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG_LEVELS = exports.LOGGING_MODE = exports.LOGGING_EVENT_EMITTER_CHANNEL = exports.FEATURE_NAME = void 0;
var _features = require("../../loaders/features/features");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const LOG_LEVELS = exports.LOG_LEVELS = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
  TRACE: 'TRACE'
};
const LOGGING_MODE = exports.LOGGING_MODE = {
  OFF: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  TRACE: 5
};
const LOGGING_EVENT_EMITTER_CHANNEL = exports.LOGGING_EVENT_EMITTER_CHANNEL = 'log';
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.logging;